import React, { ReactElement } from 'react';
import { Cell } from 'react-table';
import { Flex, Switch } from '@chakra-ui/react';
import PlatformTooltip from '@/components/tooltip/PlatformTooltip';
import { ActionButtonColumnProps } from '../../utils/types';

export const ApiToggleButtonCell = ({ value, row, column }: Cell): ReactElement => {
  const { getProps } = column as ActionButtonColumnProps;
  const hasPermission = getProps?.hasPermission ?? true;

  const toggleButton = (
    <Flex
      w={10}
      cursor={hasPermission ? 'pointer' : 'not-allowed'}
      onClick={() => {
        if (hasPermission) {
          getProps?.onApiKeyToggle?.(row.values.credentialId);
        }
      }}
    >
      <Switch
        isChecked={value === 'active' || value === true}
        pointerEvents="none"
        colorScheme="blue"
        isDisabled={!hasPermission}
      />
    </Flex>
  );

  if (!hasPermission) {
    return (
      <PlatformTooltip
        description="You don't have permission to toggle this API key"
        tooltipProps={{ placement: 'bottom-start' }}
      >
        {toggleButton}
      </PlatformTooltip>
    );
  }

  return toggleButton;
};
